// extracted by mini-css-extract-plugin
module.exports = {"HTMLContent":"HTMLContent_HTMLContent__8KqNo","padded":"HTMLContent_padded__lh3zp","wrapped":"HTMLContent_wrapped__2zIrl"};